module.exports = __webpack_public_path__ + "static/media/n2.88d1254b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/n2.png
// module id = 1331
// module chunks = 1